<template>
    <div>
        <div class="d-none d-md-block">
<!--            <div class="row">-->
<!--                <div class="col-md-6">-->
                    <nav class="nav nav-pills cursus-nav cursus-nav--dark">
                        <a class="nav-link" :class="{ 'active': !value.category }" href="#" @click.prevent="handleChanged(null)">
                            Tout
                        </a>
                        <template v-for="category in criterias.categories">
                            <a class="nav-link" :class="{ 'active': isActive(category) }" href="#" @click.prevent="handleChanged(category.id)">
                                {{ label(category) }}
                            </a>
                        </template>
                    </nav>
<!--                </div>-->
<!--                <div class="col-md-6">-->
<!--                    <nav class="nav nav-pills cursus-nav cursus-nav&#45;&#45;dark">-->
<!--                        <template v-for="category in criterias.categories.slice(3)">-->
<!--                            <a class="nav-link" :class="{ 'active': isActive(category) }" href="#" @click.prevent="handleChanged(category.id)">-->
<!--                                {{ label(category) }}-->
<!--                            </a>-->
<!--                        </template>-->
<!--                    </nav>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="d-md-none">
            <label for="category" class="d-block">catégorie</label>
            <b-form-select
                id="category"
                class="custom-select pr-5"
                :value="currentCategory"
                @change="handleChanged"
            >
                <option :value="null">tout</option>
                <template v-for="category in criterias.categories">
                    <option :value="category.id">{{ label(category) }}</option>
                </template>
            </b-form-select>
        </div>
    </div>
</template>

<script>
    import { BFormSelect } from 'bootstrap-vue';

    export default {
        components: {
            BFormSelect,
        },
        props: {
            criterias: Object,
            value: Object,
        },
        computed: {
            currentCategory() {
                return this.value.category || null;
            },
        },
        methods: {
            handleChanged(categoryId) {
                this.$emit('input', {
                    ...this.value,
                    category: categoryId || undefined,
                });
            },
            label(category) {
                return category.name?.toLowerCase();
            },
            isActive(category) {
                return this.value.category == category.id;
            },
        }
    }
</script>
